import LoggerApi from 'api/LoggerApi';

class Logger {
  public constructor(private readonly loggerApi: LoggerApi) {}

  public debug(...args: unknown[]): Promise<Response | void> {
    return this.log(...args, { type: 'debug' });
  }

  public info(...args: unknown[]): Promise<Response | void> {
    return this.log(...args, { type: 'info' });
  }

  public error(...args: unknown[]): Promise<Response | void> {
    return this.log(...args, { type: 'error' });
  }

  public log(...args: unknown[]): Promise<Response | void> {
    return this.loggerApi.fetch(...args);
  }
}

export const logger = new Logger(new LoggerApi());
